<div class="tooltip-wrapper tooltip-{{ direction }}" [style.top.px]="top" [style.left.px]="left">
  <div *ngIf='!hideArrow' class="tooltip-arrow-wrapper">
    <div class="tooltip-arrow"></div>
  </div>
  <div *ngIf="hasBottomDirection()"
       class="tooltip-text"
       #tooltipText
       [style.top.px]="tooltipTextTop"
       [style.left.px]="tooltipTextLeft"
       [attr.data-automation-id]="'bc-tooltip-text-bottom'">
    {{ text }}
  </div>
  <div *ngIf="!hasBottomDirection()"
       class="tooltip-text"
       #tooltipText
       [attr.data-automation-id]="'bc-tooltip-text-non-bottom'">
    {{ text }}
  </div>
</div>
